import React from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}
export function FadeIn({
  children,
  delay = 0,
  className = ''
}: FadeInProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay
  }} className={className} data-id="element-153">
      {children}
    </motion.div>;
}